import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .use(new LanguageDetector(null, { lookupLocalStorage: "lng" })) // Utilisation d'une variable custom dans le localStorage pour contourner les manip de LanguageDetector
  .init({
    debug: false,
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Charge les fichiers selon namespace
    },
    detection: {
      order: ["localStorage", "navigator"], // Détecte d'abord dans LocalStorage, puis navigateur
      caches: ["localStorage"], // Cache dans LocalStorage
    },
    fallbackLng: "fr",
    ns: ["common"], // Précharger les namespaces
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
  })
  .finally(() => {
    localStorage.removeItem("i18nextLng"); // Supprime la variable par défaut manipulée par LanguageDetector
  });

export default i18n;
